import {call, put, takeLatest} from "redux-saga/effects";
import {payerService} from "./payer.service";
import {
    ADD_PAYER,
    ADD_PAYER_RATE,
    CHANGE_STATUS_PAYER,
    CONNECT_MOMENTM_PAYER,
    DELETE_PAYER,
    DELETE_PAYER_RATE,
    EDIT_PAYER,
    EDIT_PAYER_RATE,
    EDIT_MOMENTM_PAYER,
    GET_MOMENTM_PAYER,
    GET_MOMENTM_PAYER_SUCCESS,
    GET_PAYER_RATES,
    GET_PAYER_RATES_SUCCESS,
    GET_PAYERS,
    GET_PAYERS_SUCCESS,
    EDIT_STATUS_MOMENTM_PAYER,
    GET_PAYER_SINGLE,
    GET_PAYER_SINGLE_SUCCESS,
    PAYER_ENABLE_TIME,
    EDIT_PAYER_TIME_RULES,
} from "./payer.types";
import {httpRequestsOnErrorsActions} from "../http_requests_on_errors";
import {httpRequestsOnLoadActions} from "../http_requests_on_load";
import {httpRequestsOnSuccessActions} from "../http_requests_on_success";

function* getPayers({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (!payload?.noLoad) {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield call(payerService.getPayersService, payload?.params);

        yield put({
            type: GET_PAYERS_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}
function* getPayerSingle({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (!payload?.noLoad) {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield call(payerService.getPayerSingleService, payload?.payerId);

        yield put({
            type: GET_PAYER_SINGLE_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* addPayer({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(payerService.addPayerService, payload.body);

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* editPayer({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(payerService.editPayerService, payload?.id, payload?.body);

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* deletePayer({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(payerService.deletePayerService, payload?.id);

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* changeStatus({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(
            payerService.changeStatusPayerService,
            payload?.id,
            payload?.body,
        );

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

/** Connect Momentm to Payer */
function* getMomentmToPayer({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (!payload?.noLoad) {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield call(payerService.getMomentmToPayerService, payload?.id);

        yield put({
            type: GET_MOMENTM_PAYER_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));

        yield put({
            type: GET_MOMENTM_PAYER_SUCCESS,
            payload: null,
        });

        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* connectMomentmToPayer({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (!payload?.noLoad) {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(payerService.connectMomentmToPayerService, payload?.body);

        yield put({
            type: GET_MOMENTM_PAYER,
            payload: {
                id: payload?.body?.payer
            },
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* editMomentmToPayer({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (!payload?.noLoad) {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(payerService.editMomentmToPayerService, payload?.id, payload?.body);

        yield put({
            type: GET_MOMENTM_PAYER,
            payload: {
                id: payload?.id
            },
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* editMomentmStatus({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (!payload?.noLoad) {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(payerService.editMomentmStatusService, payload?.id, payload?.body);

        yield put({
            type: GET_MOMENTM_PAYER,
            payload: {
                id: payload?.id,
                noLoad: true
            },
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

/** End */

function* getPayerRates({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (!payload?.noLoad) {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield call(payerService.getPayersRatesService, payload?.params);

        yield put({
            type: GET_PAYER_RATES_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));

        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* addPayerRate({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(payerService.addPayerRatesService, payload.body);

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* editPayerRate({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(payerService.editPayerRatesService, payload?.id, payload?.body);
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* deletePayerRate({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(payerService.deletePayerRatesService, payload?.id);

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* enablePayerApptTime({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(payerService.enablePayerApptTimeService, payload?.payerId, payload?.body);
        const res = yield call(payerService.getPayerSingleService, payload?.payerId);

        yield put({
            type: GET_PAYER_SINGLE_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* editPayerTimeRules({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(payerService.editPayerTimeRulesService, payload?.payerId, payload?.body);
        const res = yield call(payerService.getPayerSingleService, payload?.payerId);

        yield put({
            type: GET_PAYER_SINGLE_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

export const watchPayer = function* watchPayer() {
    yield takeLatest(GET_PAYERS, getPayers);
    yield takeLatest(GET_PAYER_SINGLE, getPayerSingle);
    yield takeLatest(ADD_PAYER, addPayer);
    yield takeLatest(EDIT_PAYER, editPayer);
    yield takeLatest(DELETE_PAYER, deletePayer);
    yield takeLatest(CHANGE_STATUS_PAYER, changeStatus);

    yield takeLatest(GET_MOMENTM_PAYER, getMomentmToPayer);
    yield takeLatest(CONNECT_MOMENTM_PAYER, connectMomentmToPayer);
    yield takeLatest(EDIT_MOMENTM_PAYER, editMomentmToPayer);
    yield takeLatest(EDIT_STATUS_MOMENTM_PAYER, editMomentmStatus);

    /** Payer Rates */
    yield takeLatest(GET_PAYER_RATES, getPayerRates);
    yield takeLatest(ADD_PAYER_RATE, addPayerRate);
    yield takeLatest(EDIT_PAYER_RATE, editPayerRate);
    yield takeLatest(DELETE_PAYER_RATE, deletePayerRate);

    /** Appt Time Rules*/
    yield takeLatest(EDIT_PAYER_TIME_RULES, editPayerTimeRules);
    yield takeLatest(PAYER_ENABLE_TIME, enablePayerApptTime);
};
